import { supabase } from '@/lib/supabase'
import type { Invoice } from '@/types/domain'

export const invoicesRepo = {
  async findAll(): Promise<Invoice[]> {
    const { data, error } = await supabase
      .from('invoices')
      .select('*, customer:customer_id(name), client:client_id(name)')
      .order('created_at', { ascending: false })

    if (error) throw error
    return (data || []) as any
  },

  async findByClient(clientId: string): Promise<Invoice[]> {
    const { data, error } = await supabase
      .from('invoices')
      .select('*, customer:customer_id(id, name, contact_person, phone, email, address)')
      .eq('client_id', clientId)
      .order('due_date', { ascending: true })

    if (error) throw error
    return (data || []) as any
  },

  async findByCustomer(customerId: string): Promise<Invoice[]> {
    const { data, error } = await supabase
      .from('invoices')
      .select('*')
      .eq('customer_id', customerId)
      .order('due_date', { ascending: true })

    if (error) throw error
    return (data || []) as Invoice[]
  },

  async create(invoice: any): Promise<Invoice> {
    console.log('Creating invoice:', invoice)

    const { data, error } = await supabase
      .from('invoices')
      .insert(invoice as any)
      .select()
      .single()

    if (error) {
      console.error('Error creating invoice:', error)
      throw new Error(`Failed to create invoice: ${error.message}`)
    }

    console.log('Invoice created successfully:', data)
    return data as Invoice
  },

  async update(id: string, updates: any): Promise<Invoice> {
    console.log('Updating invoice:', id, 'with updates:', updates)

    const { data, error } = await supabase
      .from('invoices')
      .update(updates as never)
      .eq('id', id)
      .select()
      .single()

    if (error) {
      console.error('Error updating invoice:', error)
      throw error
    }

    console.log('Invoice updated successfully:', data)
    return data as Invoice
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase.from('invoices').delete().eq('id', id)
    if (error) throw error
  },
}
